module.exports = __webpack_public_path__ + "img/acemap.c7d62e9d.png";